module.exports = __webpack_public_path__ + "img/Speech.d5f45e29.svg";